// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--b3bac";
export var button__primary = "styles-module--button__primary--dcf6a";
export var companyValues = "styles-module--company-values--3bb81";
export var companyValuesIntro = "styles-module--company-values-intro--54f04";
export var companyValuesTitle = "styles-module--company-values-title--8d541";
export var cursor = "styles-module--cursor--c5294";
export var cursorFollower = "styles-module--cursor-follower--565c8";
export var h1Main = "styles-module--h1-main--0ab8e";
export var h1MainRedLine = "styles-module--h1-main-red-line--e0784";
export var h1MainTm = "styles-module--h1-main-tm--0d745";
export var headingCentered = "styles-module--heading-centered--f1365";
export var headline = "styles-module--headline--bd4b4";
export var hero = "styles-module--hero--21e6a";
export var heroChatContainer = "styles-module--hero-chat-container--05ace";
export var heroWrapper = "styles-module--hero-wrapper--82ddb";
export var introMain = "styles-module--intro-main--a0f18";
export var noScroll = "styles-module--no-scroll--f0b3a";
export var pageTemplatePageGame = "styles-module--page-template-page-game--c1cb6";
export var section__wrapper = "styles-module--section__wrapper--72bed";
export var section__wrapperLarge = "styles-module--section__wrapper--large--1030a";
export var typewriterCursor = "styles-module--typewriter-cursor--bb87d";
export var vertText = "styles-module--vert-text--357b9";
export var vertTextDot = "styles-module--vert-text-dot--334bb";
export var vertTextLine = "styles-module--vert-text-line--91d69";